function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import axios from 'axios';
import { generateUniqueId } from 'seagull/utils/generateUniqueId';
import { HttpHeaders } from "../constants";
import { ErrorResponse } from "../infra/ErrorResponse";
import { selectors } from "./state-selectors";
export let APIHost = /*#__PURE__*/function (APIHost) {
  APIHost["KYB"] = "kyb";
  APIHost["Plaid"] = "plaid";
  APIHost["Scout"] = "scout";
  APIHost["Mgmt"] = "mgmt";
  APIHost["Cato"] = "cato";
  APIHost["External"] = "external";
  APIHost["Old"] = "old";
  return APIHost;
}({});

// eslint-disable-next-line @typescript-eslint/no-explicit-any

export function initSendRequest(_ref) {
  let {
    slackClient: {
      sendRoleIntentLoggerMessage
    },
    getState,
    getCookie,
    onCookieChange,
    onLogout,
    onNoAccess,
    onReportToSentry
  } = _ref;
  return function sendRequest(options) {
    const {
      method,
      params = {},
      data = {},
      apiHost,
      disableAuth,
      forceAuthorizationHeader,
      authToken,
      url,
      disableSentry,
      urlForSentry,
      config,
      allowedForAccountants,
      disable403Handling
    } = options;
    const {
      mgmtHost,
      apiHost: apiHostname,
      apiGatewayHost,
      useAuthorizationHeader
    } = getState().session;
    let actualHost;
    if (apiHost === APIHost.Mgmt) {
      actualHost = mgmtHost;
    } else if ([APIHost.Plaid, APIHost.Scout, APIHost.Cato, APIHost.KYB, APIHost.External].includes(apiHost)) {
      actualHost = apiGatewayHost;
    } else {
      actualHost = apiHostname;
    }
    const fullUrl = actualHost + url;
    const prevCookie = getCookie();
    const axiosConfig = _objectSpread(_objectSpread({}, config), {}, {
      withCredentials: true,
      params
    });
    if (!axiosConfig.headers) {
      axiosConfig.headers = {};
    }
    if (!axiosConfig.headers[HttpHeaders.ContentType]) {
      axiosConfig.headers[HttpHeaders.ContentType] = 'application/json';
    }
    if ([APIHost.Plaid, APIHost.Scout, APIHost.KYB, APIHost.Cato].includes(apiHost)) {
      axiosConfig.headers = _objectSpread(_objectSpread({}, axiosConfig.headers), {}, {
        ['x-api-host']: apiHost
      });
    }
    const actualAuthToken = (disableAuth || !useAuthorizationHeader) && !forceAuthorizationHeader ? null : authToken !== null && authToken !== void 0 ? authToken : getState().authToken;
    if (actualAuthToken) {
      axiosConfig.headers.Authorization = "Bearer ".concat(actualAuthToken);
    }
    if (window._sessionId) {
      axiosConfig.headers[HttpHeaders.SessionId] = window._sessionId;
    }
    const requestId = generateUniqueId('request');
    axiosConfig.headers[HttpHeaders.RequestId] = requestId;
    const isGetRequest = method === 'get';
    if (!isGetRequest && selectors.user.isAccountant(getState()) && !allowedForAccountants) {
      const userId = selectors.user.id(getState());
      const businessId = selectors.user.businessId(getState());
      const text = "An accountant sent a request to ".concat(urlForSentry || url, " (userId=").concat(userId, "; businessId=").concat(businessId, "; location=").concat(location.href, ")");
      sendRoleIntentLoggerMessage(text);
    }
    const request = axios.request(_objectSpread(_objectSpread({
      method,
      url: fullUrl
    }, axiosConfig), {}, {
      data
    }));
    return request.then(response => {
      if (prevCookie !== getCookie()) {
        onCookieChange();
      }
      return response;
    }).catch(err => {
      const e = new ErrorResponse(err);
      const is401 = e.status === 401;
      const is403ForReviewer = e.status === 403 && selectors.user.isReviewer(getState());
      const isImpersonating = !!selectors.impersonatingAs(getState());
      if (is401 || is403ForReviewer) onLogout();
      if (!disable403Handling && e.status === 403) onNoAccess();
      const disableSentryReporting = isImpersonating || is401 || is403ForReviewer || typeof disableSentry === 'function' && disableSentry(e);
      if (!disableSentryReporting && e.status) {
        onReportToSentry({
          message: "Request (".concat(method.toUpperCase(), " ").concat(urlForSentry || fullUrl, ") failed with status code ").concat(e.status),
          requestId,
          method,
          url: fullUrl,
          responseBody: e.body ? JSON.stringify(e.body) : ''
        });
      }
      throw err;
    });
  };
}